const sendNotification = (title, message, link) => {
	const notification = new Notification(title, {
		body: message,
		icon: require('@/assets/icon.png')
	})
	setTimeout(() => {
		notification.close()
	}, 10 * 1000)
	notification.addEventListener('click', () => {
		window.open(link, '_blank')
	})
}

const notifier = (title, message, link) => {
	if (Notification.permission === 'granted') {
		sendNotification(title, message, link)
		return
	}
	if (Notification.permission !== 'denied') {
		Notification.requestPermission(permission => {
			if (permission === 'granted') {
				sendNotification(title, message, link)
			}
		})
	}
}

export default {
	notifier
}



// WEBPACK FOOTER //
// ./src/services/desktop_notifier.js